<template>
    <div class="product-container" v-loading="loadProduct">
        <div class="product-title">
            {{article.title}}
        </div>
        <div class="product-content">
            {{article.content}}
        </div>
        <div class="feed-media flex">
            <FeedImage v-for="(img, index) in imageList" :key="index" :imgUrl="img" :urlList="article.uriKey"/>
        </div>
        <div class="user-name">{{initUserName}}</div>
    </div>
</template>
<script>
import { apiMap } from '../../../utils/apiMap';
import FeedImage from '../../friend/feed-image';
export default {
    name: 'relatice-article',
    props: {
        productId: Number,
    },
    components: {
        FeedImage
    },
    data() {
        return {
            article: {},
            imageList: [],
            loadProduct: true,
        }
    },
    computed: {
        initUserName() {
            if (this.article.hasOwnProperty('userInfo')) {
                return `添加人： ${this.article.userInfo.realName}`
            }else {
                return ''
            }
        }
    },
    beforeDestroy() {
        this.imageList = []
    },
    methods: {
        getProductDetail() {
            // console.log(this.productId)
            // token modelId modelType=1 self=2 feedDetail
            let _this = this;
            let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
            _this.$axios({
                baseURL: apiMap['commonUrl'],
                method: apiMap['feedDetail']['method'],
                url: apiMap['feedDetail']['url'],
                params: {
                    token: loginUser.token,
                    modelId: _this.productId,
                    modelType: 1,
                    self: 2,
                } 
            }).then(function (response) {
                // console.log(response.data)
                // _this.feedShade = false;
                if (response.data.result.statusCode==1) { 
                    _this.article = response.data.result.data;
                    _this.loadProduct = false;
                    if (response.data.result.data.uriKey &&  response.data.result.data.uriKey[0]) {
                        _this.imageList = response.data.result.data.uriKey.slice(0,3);
                    }else {
                        _this.imageList = []
                    }
                    
                } else {

                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    watch: {
        productId() {
            this.loadProduct = true;
            this.imageList = [];
            this.getProductDetail()
        }
    }
}
</script>
<style scoped>
.product-container {
    min-height: 60px;
    padding: 15px 15px 15px 20px;
}

.product-title {
    line-height: 30px;
    font-weight: bold;
    font-size: 16px;
}

.product-content {
    font-size: 16px;
    line-height: 25px;
    white-space: pre-line;
}

.user-name {
    margin-top: 15px;
    color: #808080;
}
</style>